import { RelocationsApiAdapter } from '../adapters/RelocationsApiAdapter';
import { RelocationListFilters, RelocationModel } from '../models/Relocation';

export interface RelocationsServicePage {
  relocations: RelocationModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class Service {
  constructor(private apiAdapter: RelocationsApiAdapter) {}

  async getPaginated(filters: RelocationListFilters = {}): Promise<RelocationsServicePage> {
    return this.apiAdapter.getRelocationsPaginated(filters);
  }
}
